import { graphql } from '@teachino/shared-infrastructure';
import type { ResultOf } from 'gql.tada';

export const materialDetailsFragment = graphql(`
  fragment MaterialDetails on Material {
    __typename
    id
    name
    icon
    duration
    migratedToMaterial
    topic {
      __typename
      name
      id
      usage
    }
    contentHtml {
      __typename
      html
    }
    permissions {
      canEditItem
      canDuplicateItemIntoTopic
      canDeleteItemFromTopic
      canViewItemSnippetNote
      canEditItemSnippetNote
      canViewItem
    }
    contentStatistics {
      __typename
      fileCount
      linkCount
      imageCount
      noteCount
      interactiveAssignmentCount
    }
    originDetails {
      id
      newAdditions
      contentChanged
    }
    initialIpiRequestId
  }
`);

type MaterialDetailsFragment = ResultOf<typeof materialDetailsFragment>;

export type MaterialDetails = Omit<
  MaterialDetailsFragment,
  'originDetails' | 'contentHtml' | 'contentJson'
> & {
  html: string;
};

export function convertMaterialFragment(
  material: MaterialDetailsFragment,
): MaterialDetails {
  const html = material.contentHtml?.html ?? '';
  return {
    ...material,
    html,
  };
}
